import React from 'react';
import { Box, Stat, StatLabel, StatNumber, StatHelpText } from '@chakra-ui/react';

const StatCard = ({ label, value, help }) => (
  <Box bg="gray.800" color="white" borderRadius="lg" p={6} boxShadow="md">
    <Stat>
      <StatLabel>{label}</StatLabel>
      <StatNumber fontSize="2xl">{value}</StatNumber>
      <StatHelpText>{help}</StatHelpText>
    </Stat>
  </Box>
);

export default StatCard; 